<template>
  <base-container>
    <ArtisanGrid
      metaKey="SysRoleInfo"
      @setPermission="setPermission"
      :metaInited="metaInited"
    >
    </ArtisanGrid>
    <artisan-dialog
      ref="dialog"
      :title="title"
      width="70%"
      height="70%"
      :visible.sync="isShow"
      v-loading="isLoading"
    >
      <el-row style="height: 100%">
        <el-col
          :span="12"
          class="padding12"
          style="height: 100%; overflow: auto"
        >
          <ArtisanMenu
            v-if="checkMenuTree.length"
            background-color="#3C3C3C"
            text-color="#C4C4C4"
            active-text-color="#ffd04b"
            style="border: none"
            :default-openeds="menuOpenIndexs"
            :menus="checkMenuTree"
          ></ArtisanMenu>
          <el-empty v-else description="无授权菜单,请在右侧设置"></el-empty>
        </el-col>
        <el-col
          :span="12"
          class="padding12 back-white"
          style="height: 100%; overflow: auto"
        >
          <div>
            <el-button type="primary" size="mini" @click="allCheck"
              >全选</el-button
            >
            <el-button type="primary" size="mini" @click="allCancelCheck"
              >全不选</el-button
            >
          </div>
          <el-tree
            class="margin12"
            :data="menuTree"
            :default-checked-keys="checkedKeys"
            :default-expanded-keys="expandedKeys"
            node-key="id"
            ref="tree"
            :expand-on-click-node="false"
            highlight-current
            :props="defaultProps"
          >
            <span
              class="custom-tree-node border-bottom"
              slot-scope="{ node }"
              @click="nodeClick(node)"
            >
              <span>{{ node.label }}</span>
              <i
                style="color: #66b1ff"
                v-show="node.data.isCheck"
                class="el-icon-success"
              ></i>
            </span>
          </el-tree>
        </el-col>
      </el-row>

      <template #footer>
        <el-button type="primary" size="mini" @click="setRolePermission"
          >确认授权</el-button
        >
      </template>
    </artisan-dialog>
  </base-container>
</template>

<script>
import { list } from "@/api/sys/menu";
import { buildTree } from "@/util/util";
import { getPermission, setPermission } from "@/api/sys/role";
import ArtisanMenu from "@/components/ArtisanMenu.vue";
export default {
  components: {
    ArtisanMenu,
  },
  data() {
    return {
      isShow: false,
      isLoading: false,
      dialogLoading: false,
      row: "",
      menus: [],
      userRoles: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      checkedKeys: [],
    };
  },
  computed: {
    title() {
      let title = "";
      if (this.row) title = this.row.name + "--角色权限设置";
      return title;
    },
    checkMenuTree() {
      let checkMenus = this.menus.filter(
        (c) => (c.menuType = "menu" && c.isCheck)
      );
      return buildTree(checkMenus);
    },
    menuOpenIndexs() {
      return this.checkMenuTree.map((c) => c.code);
    },
    menuTree() {
      return buildTree(this.menus);
    },
    expandedKeys() {
      return this.menus.map((c) => c.id);
    },
  },
  methods: {
    metaInited(meta) {},
    allCheck() {
      this.menus.forEach((c) => (c.isCheck = true));
    },
    allCancelCheck() {
      this.menus.forEach((c) => (c.isCheck = false));
    },
    nodeClick(node) {
      node.data.isCheck = !node.data.isCheck;
      if (node.data.isCheck) {
        this.checkParent(node.parent);
      } else {
        this.checkChildren(node.childNodes);
      }
    },
    checkParent(node) {
      if (node) {
        node.data.isCheck = true;
        this.checkParent(node.parent);
      }
    },
    checkChildren(childNodes) {
      if (childNodes && childNodes.length) {
        childNodes.forEach((c) => {
          c.data.isCheck = false;
          this.checkChildren(c.childNodes);
        });
      }
    },
    setPermission(row) {
      this.row = row;
      this.isShow = true;
      this.isLoading = true;
      this.checkedKeys = [];
      list({ filterParams: [{ name: "isValid", value: true }],orderBy:"sortNo",isDesc:false })
        .then((res) => {
          let data = res.data.data;
          data.forEach((item) => {
            item.isCheck = false;
          });
          this.menus = data;
          return getPermission(row.id);
        })
        .then((res) => {
          let data = res.data.data;
          this.menus.forEach((c) => {
            if (data.indexOf(parseInt(c.id)) >= 0) {
              c.isCheck = true;
            }
          });
          this.isLoading = false;
        });
    },
    setRolePermission() {
      this.$refs.dialog.confirm({ msg: "确认授权？" }).then(() => {
        let ids = this.menus.filter((c) => c.isCheck).map((c) => c.id);
        this.dialogLoading = true;
        setPermission(this.row.id, ids.join(","))
          .then((res) => {
            this.$message({
              message: "授权成功！",
              type: "success",
            });
            this.dialogLoading = false;
            this.isShow = false;
          })
          .catch(() => {
            this.dialogLoading = false;
          });
      });
    },
  },
};
</script>

<style scoped>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>